module.exports = __webpack_public_path__ + "static/img/34.d963f7c9.png";